export const companyEnum = Object.freeze({
    ESC: 1,
    ESS: 2,
    ESP: 3
});